<app-course-catalogue-details-card id="included" i18n-label label="Included">
  <div class="flex flex-col gap-5">
    <div>
      <ul>
        <li class="list-item list-disc list-inside text-primary">
          <span i18n class="text-slate-700">
            The camp lasts from Sunday 18 o'clock until Friday 16 o'clock
          </span>
        </li>
        <li class="list-item list-disc list-inside text-primary">
          <span i18n class="text-slate-700">
            All meals from Sunday's dinner until Friday's lunch
          </span>
        </li>
        <li class="list-item list-disc list-inside text-primary">
          <span i18n class="text-slate-700">
            All activities and materials required for the camp
          </span>
        </li>
        <li class="list-item list-disc list-inside text-primary">
          <span i18n class="text-slate-700">
            Enthousiastic guidance by one Skillz monitor per group of max. 12
            participants
          </span>
        </li>
        <li class="list-item list-disc list-inside text-primary">
          <span i18n class="text-slate-700">
            Extra support by a head monitor and regional manager
          </span>
        </li>
      </ul>
    </div>
  </div>
</app-course-catalogue-details-card>
